"use client";

import styles from "./index.module.scss";
import TextInput from "@/app/_components/Shared/TextInput";
import {useCallback, useState} from "react";
import MailGray from "@/app/icons/mail-gray.svg";
import UserIcon from "@/app/icons/user.svg";
import IconButton from "@/app/_components/Shared/IconButton";
import axios from "axios";
import { object, string } from 'yup';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const schema = object({
    name: string().required(),
    email: string().email().required(),
    message: string().required(),
});

export default function DeleteForm() {
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState({
        "name": "",
        "email": "",
        "message": "",
    });

    const handleChange = useCallback(e => {
        setData({
            ...data,
            [e.target.name]: e.target.value,
        });
    }, [data]);

    const submit = useCallback(async () => {
        setIsLoading(true);
        schema.validate(data).then(() => {
            return axios.post(process.env.NEXT_PUBLIC_API_URL + '/api/tickets', {
                name: data.name,
                email: data.email,
                message: `${data.message} \n\n Service: delete account`,
            }).then(response => {
                toast('Delete request sent successfully.');
                return setData({
                    "name": "",
                    "email": "",
                    "message": "",
                })
            }).catch(error => {
                toast.error('Failed to delete account. Please try again later');
            });
        }).catch(error => {
            toast.error(error.message);
        }).finally(() => {
            setIsLoading(false);
        });
    }, [data])
    return (
        <div className={styles.container}>
            <h1>Delete Your Account</h1>
            <div className={styles.section}>
                <TextInput placeholder="Your Name" name="name" required onChange={handleChange} icon={MailGray} />
                <TextInput type="email" placeholder="Email ID" name="email" required onChange={handleChange} icon={UserIcon} />
            </div>
            <div className={styles.section}>
                <TextInput type="textarea" placeholder="Your Message" name="message" required onChange={handleChange} />
            </div>
            <div className={styles.section}>
                <IconButton onClick={submit} isLoading={isLoading} disabled={isLoading}>
                    Submit
                </IconButton>
            </div>
        </div>
    );
}
